import { store } from '../../stores/store';
import { COUNTRY_SPECIFIC_TRANSLATION_CONFIG } from './country-specific-translation.config';

export const getCountryTranslationKey = (
  translationKey: string,
  countryCode: string | undefined = store.localizationsStore.selectedCountry
    ?.country_code
) => {
  if (!countryCode) return translationKey;

  const normalizedCountryCode = countryCode?.trim().toUpperCase();

  const alternativeTranslationConfig =
    COUNTRY_SPECIFIC_TRANSLATION_CONFIG[translationKey];

  if (!alternativeTranslationConfig) return translationKey;

  const { settingCategory, settingName, settingValue } =
    alternativeTranslationConfig;

  const countrySettings = store.shipmentCountriesStore.getSettingsOrDefault(
    normalizedCountryCode
  );

  const relatedSetting = countrySettings.find(
    (x) =>
      x.category === settingCategory &&
      x.name === settingName &&
      x.value === settingValue
  );

  return relatedSetting
    ? alternativeTranslationConfig.transKey
    : translationKey;
};
